import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages';
import UnderConstruction from './components/UnderConstruction';

const AppRouter: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/demo" element={<UnderConstruction />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;